import React from 'react'

import { useIntl } from 'react-intl'
import InputRecipients from './InputRecipients/InputRecipients'
import SelectGroup from './SelectGroup/SelectGroup'

import {
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Flex,
  FlexItem,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_ITALIC_LIGHT,
  SpacingVertical,
  SPACING_24
} from 'mailup-web-components'
import { useRecoilState } from 'recoil'
import {
  recipientsState,
  ACTUAL_VIEW_RECIPIENTS,
  ACTUAL_VIEW_GROUPS
} from 'Pages/QuickSend/recoil/state/state'

const Recipients = () => {
  const intl = useIntl()

  const [{ actualView }, setActualView] = useRecoilState(recipientsState)

  const switchView = () => {
    setActualView(prev => ({
      ...prev,
      actualView:
        prev.actualView === ACTUAL_VIEW_RECIPIENTS
          ? ACTUAL_VIEW_GROUPS
          : ACTUAL_VIEW_RECIPIENTS
    }))
  }

  return (
    <>
      <Flex justifyContent='space-between'>
        <FlexItem>
          {actualView === ACTUAL_VIEW_RECIPIENTS ? (
            <>
              <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                {intl.formatMessage({ id: 'Load.MailupCommon.Recipients' })}{' '}
              </Text>
              {' * '}
              <Text variant={TEXT_VARIANT_ITALIC_LIGHT} htmlElement='span'>
                {intl.formatMessage({
                  id: 'Load.QuickSend.EmailAddressesDescription'
                })}
              </Text>
            </>
          ) : (
            <>
              <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                {intl.formatMessage({
                  id: 'Load.QuickSend.SelectSmallGroupLabel'
                })}
              </Text>
            </>
          )}
        </FlexItem>
        <Link variant={LINK_VARIANT_HIGHLIGHT} onClick={switchView}>
          {actualView === ACTUAL_VIEW_GROUPS
            ? intl.formatMessage({
                id: 'Load.QuickSend.ChangeSelectionRecipient'
              })
            : intl.formatMessage({
                id: 'Load.QuickSend.SelectSmallGroupEnable'
              })}
        </Link>
      </Flex>

      <Flex margin='4px 0 0 0'>
        <FlexItem width='100%'>
          {actualView === ACTUAL_VIEW_RECIPIENTS && <InputRecipients />}
          {actualView === ACTUAL_VIEW_GROUPS && <SelectGroup />}
        </FlexItem>
      </Flex>
      <SpacingVertical variant={SPACING_24} />
    </>
  )
}

export default Recipients
